import { useEffect, useState } from 'react';

import { productDefaultValue, ProductViewModel } from '@models/Product';
import { ProductService } from '@services/Product';

export const useProductGet = () => {
  const [id, setId] = useState<number | null>(null);
  const [product, setProduct] = useState<ProductViewModel>(productDefaultValue);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string[] | undefined>([]);

  const loadData = async (id: number) => {
    setId(id);
    setIsLoading(true);
    const result = await ProductService.getById(id);

    if (result.isSuccess && 'data' in result) {
      setProduct(result.data);
      setIsLoading(false);
      setIsSuccess(true);
      console.log('Success: Fetched the record.');
    } else {
      console.error('Error: Failed to get record.', result.errorMessages);
      setIsSuccess(false);
      setErrorMessages(result.errorMessages);
    }
  };

  useEffect(() => {
    if (id !== null) {
      loadData(id);
    }
  }, [id]);

  return { product, isLoading, isSuccess, errorMessages, loadData };
};
